module.exports = __webpack_public_path__ + "static/media/icon_checkout_summary.ebaded5c.svg";